/// <amd-module name="Artifacts/Root/protocols/TagConstants" />
/**
TagConstants module stores application wide tags for protocol commands.
*/

export const RecycleBin = "Recycle Bin";
export const PackageList = "Package List";
export const PackageDetails = "Package Details";
